import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }, "Subscription Details", -1)
const _hoisted_4 = { class: "capitalize" }
const _hoisted_5 = { class: "capitalize" }
const _hoisted_6 = { class: "capitalize" }
const _hoisted_7 = { class: "capitalize" }
const _hoisted_8 = { class: "capitalize" }
const _hoisted_9 = { class: "mt-6" }
const _hoisted_10 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }, "Order Details", -1)
const _hoisted_12 = { class: "capitalize" }
const _hoisted_13 = { class: "capitalize" }
const _hoisted_14 = { class: "capitalize" }
const _hoisted_15 = { class: "capitalize" }
const _hoisted_16 = { class: "capitalize" }
const _hoisted_17 = { class: "capitalize" }
const _hoisted_18 = { class: "capitalize" }
const _hoisted_19 = { class: "capitalize" }
const _hoisted_20 = { class: "capitalize" }
const _hoisted_21 = { class: "flex items-center space-x-3" }
const _hoisted_22 = { class: "mt-1 capitalize" }
const _hoisted_23 = { class: "mt-2" }
const _hoisted_24 = { class: "flex items-center mt-1 space-x-3" }
const _hoisted_25 = {
  key: 0,
  class: "px-2 text-sm text-white rounded-full bg-success w-fit"
}
const _hoisted_26 = {
  key: 1,
  class: "px-2 text-sm text-black rounded-full bg-warning w-fit"
}
const _hoisted_27 = {
  key: 2,
  class: "mt-1"
}
const _hoisted_28 = { class: "mt-1" }

import { ref } from "vue";
import { useRoute } from "vue-router";

import TitleHeader from "@/components/TitleHeader.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import ToggleCheckbox from "@/components/ToggleCheckbox.vue";

import api from "@/api/api";
import { License, Transaction } from "@/types";
import { useGlobalStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionOrderView',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const globalStore = useGlobalStore();

const subscription = ref({} as Transaction);
const license = ref({} as License);
const booking = ref({} as any);

function intlFormat(value: number) {
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: subscription.value.currency ? subscription.value.currency : "GBP" }).format(value);
}

function calculateDiscount(subscription: Transaction) {
  console.log("Calculate Discount");
  if (subscription && subscription.discount) {
    const original_net_price = calculateOriginalNetPrice(subscription);
    console.log("original_net_price " + original_net_price);
    const discount_amount = Number(original_net_price) - Number(subscription.net_price);
    return intlFormat(discount_amount);
  }

  return intlFormat(0);
}

function calculateOriginalNetPrice(transaction: Transaction) {
  if (transaction && transaction.discount) {
    const discountDivisor = 100 - Number(transaction.discount!.percent_amount);
    const net_priceMultiplied = Number(transaction.net_price) * 100;
    const original_net_price = net_priceMultiplied / discountDivisor;
    return original_net_price;
  }

  return intlFormat(0);
}

function calculateTotal(subscription: Transaction) {
  let total = Number(subscription.net_price) + Number(subscription.vat);

  // if (subscription.discount) {
  //   return total - calculateDiscount(subscription, false);
  // }

  return total;
}

async function markAsInvoiceIssued(id: string) {
  try {
    const response = await api.subscriptions.markSubscriptionInvoiceIssued(id);
    subscription.value.invoice_issued = response.data.transaction.invoice_issued;
    subscription.value.processed = response.data.transaction.processed;

    const issued = response.data.transaction.invoice_issued ? "issued" : "not issued";
    globalStore.toast("SUCCESS", `Invoice marked as ${issued}`);
  } catch (error) {
    globalStore.toast("ERROR", `Error updating Invoice order`);
  }
}

async function markAsInvoiceAsPaid(id: string) {
  try {
    const response = await api.subscriptions.markSubscriptionInvoiceAsPaid(id);
    subscription.value.processed = response.data.transaction.processed;

    globalStore.toast("SUCCESS", `Invoice marked as Paid`);
  } catch (error) {
    console.log(error);
    globalStore.toast("ERROR", `Error updating Licence`);
  }
}

async function fetchSubscription() {
  try {
    const response = (await api.subscriptions.getSubscription(route.params.id as string)).data;

    subscription.value = response.subscription;

    if (response.license) {
      license.value = response.license;
    }

    if (response.booking) {
      booking.value = response.booking;
    }
  } catch (error) {
    window.location.href = "/error";
  }
}

;(
  ([__temp,__restore] = _withAsyncContext(() => fetchSubscription())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TitleHeader, {
      title: _ctx.$t('subscription-details'),
      class: "mt-6"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(ListRowItem, {
          title: _ctx.$t('user')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_4, _toDisplayString(subscription.value.user.first_name) + " " + _toDisplayString(subscription.value.user.last_name), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('type')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_5, _toDisplayString(subscription.value.type === "AnonymousGroup" ? "License" : subscription.value.type), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        (subscription.value.type === 'AnonymousGroup')
          ? (_openBlock(), _createBlock(ListRowItem, {
              key: 0,
              title: _ctx.$t('License')
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    class: "text-blue-500",
                    to: { name: 'License', params: { oid: license.value.organisation_id, lid: license.value.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" #" + _toDisplayString(license.value.id), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        (subscription.value.type === 'Group' && subscription.value.booking_id)
          ? (_openBlock(), _createBlock(ListRowItem, {
              key: 1,
              title: _ctx.$t('group-booking')
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    class: "text-blue-500",
                    to: { name: 'User_Order', params: { id: subscription.value.event_id, bookingId: subscription.value.booking_id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" #" + _toDisplayString(subscription.value.booking_id), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        (subscription.value.type === 'Individual' && booking.value.id)
          ? (_openBlock(), _createBlock(ListRowItem, {
              key: 2,
              title: _ctx.$t('booking')
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    class: "text-blue-500",
                    to: { name: 'User_Order', params: { id: booking.value.event_id, bookingId: booking.value.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" #" + _toDisplayString(booking.value.id), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        (subscription.value.payment_gateway !== 'Invoice')
          ? (_openBlock(), _createBlock(ListRowItem, {
              key: 0,
              title: _ctx.$t('payment-gateway-order-id')
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_12, _toDisplayString(subscription.value.order_id), 1)
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        (subscription.value.payment_gateway === 'Stripe')
          ? (_openBlock(), _createBlock(ListRowItem, {
              key: 1,
              title: _ctx.$t('payment-gateway-customer-id')
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_13, _toDisplayString(subscription.value.user.stripe_customer_id), 1)
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        (subscription.value.discount && subscription.value.discount)
          ? (_openBlock(), _createBlock(ListRowItem, {
              key: 2,
              title: _ctx.$t('discount-id')
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_14, _toDisplayString(subscription.value.discount?.id), 1)
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        (subscription.value.discount)
          ? (_openBlock(), _createBlock(ListRowItem, {
              key: 3,
              title: _ctx.$t('discount-percentage')
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_15, _toDisplayString(subscription.value.discount.percent_amount) + "%", 1)
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        _createVNode(ListRowItem, {
          title: _ctx.$t('subscription-amount')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_16, _toDisplayString(intlFormat(subscription.value.net_price)), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('discount-amount')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_17, _toDisplayString(calculateDiscount(subscription.value)), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('tax-amount')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_18, _toDisplayString(intlFormat(subscription.value.vat)) + " (" + _toDisplayString(subscription.value.tax_percent ?? 0) + ")%", 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('total-amount')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_19, _toDisplayString(intlFormat(calculateTotal(subscription.value))), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('payment-method')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_20, _toDisplayString(subscription.value.payment_gateway), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        (subscription.value.payment_gateway === 'Invoice')
          ? (_openBlock(), _createBlock(ListRowItem, {
              key: 4,
              title: _ctx.$t('invoice-issued')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(subscription.value.invoice_issued ? "Yes" : "No"), 1),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(ToggleCheckbox, {
                      value: subscription.value.invoice_issued,
                      onToggle: _cache[0] || (_cache[0] = ($event: any) => (markAsInvoiceIssued(subscription.value.id)))
                    }, null, 8, ["value"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        _createVNode(ListRowItem, {
          title: _ctx.$t('status')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              (subscription.value.processed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Confirmed"))
                : _createCommentVNode("", true),
              (!subscription.value.processed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Pending"))
                : _createCommentVNode("", true),
              (!subscription.value.processed && subscription.value.payment_gateway === 'Invoice')
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(ToggleCheckbox, {
                      value: subscription.value.processed,
                      onToggle: _cache[1] || (_cache[1] = ($event: any) => (markAsInvoiceAsPaid(subscription.value.id)))
                    }, null, 8, ["value"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["title"]),
        (subscription.value.type === 'Group')
          ? (_openBlock(), _createBlock(ListRowItem, {
              key: 5,
              title: _ctx.$t('delegates')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subscription.value.delegates, (delegate, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, [
                        _createVNode(_component_router_link, {
                          class: "text-blue-500",
                          to: { name: 'User_Profile', params: { id: delegate.user!.id } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(delegate.user!.first_name) + " " + _toDisplayString(delegate.user!.last_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})